module.exports = __webpack_public_path__ + "static/media/handle-red.0abb3b15.png";